import {
  SET_ALL_PAYMENT_METHODS_DATA_LOADING,
  SET_PAYMENT_METHODS_DATA,
  SET_COMPANY_PAYMENT_METHODS_DATA_LOADING,
  SET_COMPANY_PAYMENT_METHODS_DATA,
  SET_ALL_PAYMENT_SETTINGS_DATA_LOADING,
  SET_PAYMENT_SETTINGS_DATA,
} from './types';
import store from '../../../../store';
import Axios from '../../../../common/util/Axios';

export const getAllPaymentMethods = () => async (dispatch) => {
  try {
    dispatch({ type: SET_ALL_PAYMENT_METHODS_DATA_LOADING, payload: true });

    const res = await Axios.get('/api/dashboard/payment-methods/get-all-payment-methods');

    dispatch({
      type: SET_PAYMENT_METHODS_DATA,
      payload: res.data.data || [],
    });

    return true;
  } catch (error) {
    dispatch({
      type: SET_PAYMENT_METHODS_DATA,
      payload: [],
    });
    return false;
  }
};

export const getCompanyPaymentMethods = () => async (dispatch) => {
  try {
    dispatch({ type: SET_COMPANY_PAYMENT_METHODS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const queryParams = {
      companyId,
    };
    if (!companyId) {
      return false;
    }

    const res = await Axios.get('/api/dashboard/company-payment-methods/get-all-company-payment-methods', {
      params: queryParams,
    });

    dispatch({
      type: SET_COMPANY_PAYMENT_METHODS_DATA,
      payload: res.data.data || [],
    });

    return true;
  } catch (error) {
    dispatch({
      type: SET_COMPANY_PAYMENT_METHODS_DATA,
      payload: [],
    });
    return false;
  }
};

export const createCompanyPaymentMethod = (companyPaymentMethod) => async (dispatch) => {
  try {
    dispatch({ type: SET_COMPANY_PAYMENT_METHODS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;

    const requestBody = {
      ...companyPaymentMethod,
    };

    const queryParams = {
      companyId,
      branchId,
    };

    const res = await Axios.post(`/api/dashboard/company-payment-methods/create-company-payment-method`, requestBody, {
      params: queryParams,
    });
    dispatch({ type: SET_COMPANY_PAYMENT_METHODS_DATA_LOADING, payload: false });
    return res.data.success;
  } catch (err) {
    dispatch({ type: SET_COMPANY_PAYMENT_METHODS_DATA_LOADING, payload: false });
    return false;
  }
};

export const updateCompanyPaymentMethod = (companyPaymentMethodData, companyPaymentMethodId) => async (dispatch) => {
  try {
    dispatch({ type: SET_COMPANY_PAYMENT_METHODS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;

    const requestBody = {
      id: companyPaymentMethodId,
      ...companyPaymentMethodData,
    };

    const queryParams = {
      companyId,
      branchId,
      companyPaymentMethodId,
    };

    const res = await Axios.post(`/api/dashboard/company-payment-methods/update-company-payment-method`, requestBody, {
      params: queryParams,
    });
    dispatch({ type: SET_COMPANY_PAYMENT_METHODS_DATA_LOADING, payload: false });
    return res.data.success;
  } catch (err) {
    dispatch({ type: SET_COMPANY_PAYMENT_METHODS_DATA_LOADING, payload: false });
    return false;
  }
};

export const findPaymentSettings = (branchId) => async (dispatch) => {
  try {
    dispatch({ type: SET_ALL_PAYMENT_SETTINGS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const queryParams = {
      companyId,
      branchId,
    };
    if (!companyId || !branchId) {
      return false;
    }
    
    const res = await Axios.get('/api/dashboard/settings/find-payment-settings-for-branch', {
      params: queryParams,
    });
    dispatch({
      type: SET_PAYMENT_SETTINGS_DATA,
      payload: res.data.data,
    });

    return true;
  } catch (error) {
    dispatch({
      type: SET_PAYMENT_SETTINGS_DATA,
      payload: [],
    });
    return false;
  }
}

export const updatePaymentSettings = (paymentSettings) => async (dispatch) => {
  try {
    dispatch({ type: SET_ALL_PAYMENT_SETTINGS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const requestBody = {
      ...paymentSettings.paymentSettingsData,
    };

    const queryParams = {
      companyId,
      branchId: paymentSettings.branchId,
    };

    const res = await Axios.post(`/api/dashboard/settings/update-payment-settings`, requestBody, {
      params: queryParams,
    });
    dispatch({ type: SET_ALL_PAYMENT_SETTINGS_DATA_LOADING, payload: false });
    return true;
  } catch (err) {
    dispatch({ type: SET_ALL_PAYMENT_SETTINGS_DATA_LOADING, payload: false });
    return false;
  }
};
